import Lenis from 'lenis'

export const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)')
export const header = document.querySelector('header')

export const lenis = new Lenis({
  anchors: {
    offset: -(header?.offsetHeight ?? 0),
    duration: prefersReducedMotion.matches ? 0 : 1.2,
    easing: (progress) => 1 - (1 - progress) ** 4,
    immediate: prefersReducedMotion.matches,
  },
})

requestAnimationFrame(function raf(time) {
  lenis.raf(time)
  requestAnimationFrame(raf)
})

// iOS Safari restores pages from bfcache (back/forward nav) with persisted scroll position.
// Scroll Lenis back to top so entry animations are visible.
window.addEventListener('pageshow', (event) => {
  if (event.persisted) {
    lenis.scrollTo(0, { immediate: true })
  }
})
